/*
 * @Author: Veto [关于活动部分 路由]
 * @Date: 2021-06-16 16:08:20 
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2022-07-26 17:17:17
 */

import QiXi from '../views/events/qixi';
import QiXiRule from '../views/events/qixi_rule';


const router = {
    '/event-qixi': QiXi,
    '/event-qixi-rule': QiXiRule,
};


export default router;